import React, { FC, useEffect, useState } from "react";
import { Aligment, Icon, Section, Tile } from "venice-ui";
import { Colors } from "../../untils/Theme";
import { t } from "../../helpers/userHelper";
import { dictionary } from "../../untils/dictionary";
import { DetailsPanelText } from "./organizations.style";
import { useStoreActions, useStoreState } from "../../store";
import { getContractMembers } from "../../helpers/organizationHelper";
import { MemeberList } from "../ContractDetails/MemeberList";
import {
  DetailPanelContent,
  DetailPanelWrapperFooter,
  DetailPanelWrapperHeader,
} from "../ItemDetailPanel/ItemDetailsPanel.styles";

interface IContractDetailsPanel {
  contractID: string;
  projectID?: string;
  handleDelete: (memberID: string) => void;
  handleAddModal: (contractID: string) => void;
  handleEditModal: (contractID: string) => void;
  handleAddProject: (contractID: string) => void;
}
export const ContractDetailsPanel: FC<IContractDetailsPanel> = ({
  contractID,
  projectID,
  handleDelete,
  handleAddModal,
  handleEditModal,
  handleAddProject,
}) => {
  const { members, contracts } = useStoreState((state) => state.organization);

  const id = projectID && projectID !== "" ? projectID : contractID;

  const [contractMemers, setContractMembers] = useState(
    getContractMembers(contractID, members, projectID)
  );

  const userManagementInContract = () => {
    handleAddModal(id);
  };

  const contractEdit = () => {
    handleEditModal(id);
  };

  const deleteContract = () => {
    handleDelete(id);
  };

  const addProject = () => {
    handleAddProject(contractID);
  };
  useEffect(() => {
    if (contractID !== "") {
      setContractMembers(getContractMembers(contractID, members, projectID));
    }
  }, [contractID, contracts, members, projectID]);

  const ifProject = () => {
    return projectID && projectID !== "";
  };
  return (
    <Tile backgroundColor={Colors.tileGray} height="inherit">
      {contractID === "" ? (
        <Aligment style={{ height: "100%" }}>
          <DetailsPanelText>
            {t(dictionary.emptyContractMembers)}
          </DetailsPanelText>
        </Aligment>
      ) : (
        <DetailPanelContent>
          <DetailPanelWrapperHeader>
            {ifProject()
              ? t(dictionary.projectMembers)
              : t(dictionary.contractMembers)}
          </DetailPanelWrapperHeader>
          <Section backgroundColor={Colors.tileGray}>
            <MemeberList orgMembers={contractMemers} />
          </Section>

          {id !== "" && (
            <DetailPanelWrapperFooter id="footer" isSingle={false}>
              <Icon
                name="people_group_check"
                size={24}
                iconColor={Colors.appBlue}
                iconHoverColor={Colors.seaBlue}
                onClick={userManagementInContract}
                iconBgHoverColor="transparent"
                iconBgColor="transparent"
                tooltip={t(dictionary.userManagement)}
                isDisabled={false}
              />
              {!projectID && (
                <Icon
                  name="note_add"
                  size={24}
                  iconColor={Colors.appBlue}
                  iconHoverColor={Colors.seaBlue}
                  onClick={addProject}
                  iconBgHoverColor="transparent"
                  iconBgColor="transparent"
                  tooltip={t(dictionary.addProject)}
                  isDisabled={false}
                />
              )}
              <Icon
                name="note_edit"
                size={24}
                iconColor={Colors.appBlue}
                iconHoverColor={Colors.seaBlue}
                onClick={contractEdit}
                iconBgHoverColor="transparent"
                iconBgColor="transparent"
                tooltip={t(dictionary.changeName)}
                isDisabled={false}
              />
              
              <Icon
                name="delete"
                size={24}
                iconColor={Colors.appBlue}
                iconHoverColor={Colors.seaBlue}
                onClick={deleteContract}
                iconBgHoverColor="transparent"
                iconBgColor="transparent"
                tooltip={t(dictionary.deleteContract)}
                isDisabled={false}
              />
            </DetailPanelWrapperFooter>
          )}
        </DetailPanelContent>
      )}
    </Tile>
  );
};
